import React from 'react';
import { Divider, Typography } from '@mui/material';
import shingMagurKoi from '../../../../../images/Agri-info/fish/ekokmas_শিং-মাগুর ও কৈ মাছ.jpg';
import useDocumentTitle from '../../../../../hooks/useDocumentTitle';

const ShingMagurKoiInfo = () => {

    // dynamic title
    useDocumentTitle("শিং-মাগুর ও কৈ মাছ");

    return (

        <div className=" rounded-3 bg-white my-4 px-5">
            <Typography
                sx={{
                    textAlign: "center",
                    pb: 2,
                    pt: 3,
                    fontWeight: 600,
                    color: 'rgb(37, 36, 36, 0.83)'
                }}
                variant="h4"
                component="div"
            >
                শিং-মাগুর ও কৈ মাছ
            </Typography>
            <Divider />

            <div className="card mt-4 mb-3 border-0 rounded-0">
                <div className="row g-0">
                    <div className="col-md-4">
                        <img src={shingMagurKoi} className="img-fluid rounded-0 h-100" alt="..." />
                    </div>
                    <div className="col-md-8">
                        <div className="card-body text-start ">
                            <p>বাংলাদেশে শিং-মাগুর ও কৈ অত্যন্ত সুস্বাদু  এবং পুষ্টিকর মাছ হিসেবে বহুল আলোচিত ও সমাদৃত। কিন্তু জলজ পরিবেশের আনুকূল্যের অভাব এবং অতিরিক্ত আহরণজনিত কারণে এসব মাছ অধুনা বিলুপ্তির পথে। এসব মাছ বিলুপ্তির হাত থেকে রক্ষার্থে বাংলাদেশ মৎস্য গবেষণা ইনস্টিটিউট ও বাংলাদেশ কৃষি বিশ্ববিদ্যালয় গবেষণা কার্যক্রম শুরু করে সাম্প্রতিক সময়ে আশাব্যঞ্জক সাফল্য অর্জন করেছে। ফলে এ জাতীয় মাছ বিলুপ্তির হাত থেকে রক্ষার উজ্জ্বল সম্ভাবনার দ্বারোদঘাটন হয়েছে।</p>
                            <p className="card-text"><b>শিং-মাগুর ও কৈ মাছ কেন চাষ করব</b><br />
                                ক. এ মাছ অত্যন্ত পুষ্টিকর ও সুস্বাদু<br />
                                খ. অধিক সংখ্যক মাছ এক সঙ্গে চাষ করা যায়।<br />
                                গ. স্বল্প গভীর পানিতে নিরাপদে চাষ করা সম্ভব।</p>

                        </div>
                    </div>
                </div>
            </div>

            <div className='text-start pb-5'>
                <p>ঘ. অন্যান্য মাছের তুলনায় এ মাছের চাহিদা ও বাজার মূল্য অনেক বেশি।<br />
                    ঙ. অতিরিক্ত শ্বাসনালী থাকায় বাতাস থেকে অঙিজেন নিয়ে এরা দিব্যি বেঁচে থাকতে পারে।    ফলে, জীবন্ত অবস্থায় বাজারজাত করা যায়।<br />
                    চ. কৃত্রিম প্রজনন কৌশল উদ্ভাবনের ফলে পর্যাপ্ত পরিমাণে পোনা উৎপাদন সম্ভব।<br />
                    ছ. রোগীর পথ্য হিসেবে এ মাছের চাহিদা ব্যাপক।<br />
                    এ প্রেক্ষাপটে প্রথমে শিং মাছের ওপর সংক্ষিপ্ত আলোকপাত করা হলো-</p>
                <p className="card-text"><b>শিং মাছ <br />আবাসস্থল:</b><br />খাল-বিল, হাওর-বাঁওড়, পুকুর-দীঘি, ডোবানালা, প্লাবনভূমি ইত্যাদি। এঁদো, কর্দমাক্ত মাটি, গর্ত, গাছের গুঁড়ির তলা ইত্যাদি জায়গায় এরা সহজেই বসবাস করতে পারে। আগাছা, কচুরিপনা, পচা পাতা, ডালপালা ঘেরা জলাশয়ে বাস করতে এদের আদৌ কোন সমস্যা হয় না।</p>
                <p className="card-text"><b>খাদ্য গ্রহণ প্রবণতা:</b><br />রেণুপর্যায়ে আর্টেমিয়া, জু-প্লাঙ্কটন, ক্ষুদ্রজলজ পোকামাকড় ইত্যাদি। বায়োপ্রাপ্ত অবস্থায়- জলজ পোকা-মাকড়, ক্ষুদ্র চিংড়ি ও মাছ, ডেট্রিটাস পচনরত প্রাণিজ দ্রব্যাদি।</p>
                <p className="card-text"><b>পরিপক্বতা :</b><br /> এ মাছ বছরে একবার প্রজনন করে থাকে এবং প্রথম বছরেই পরিপক্বতা অর্জন করে। প্রজননকাল মে থেকে সেপ্টেম্বর মাস।</p>
                <p className="card-text"><b>চাষ ব্যবস্থাপনা : </b><br />১.০ থেকে ১.৫ মিটার গভীরতা বিশিষ্ট পুকুর এ মাছ চাষের জন্য উপযোগী। সম্ভব হলে পুকুরের পানি শুকিয়ে পাড় মেরামত করে নিতে হবে। পুকুরপ্রতি শতাংশে ১ কেজি চুন, ১০ কেজি গোবর, ১০০ গ্রাম ইউরিয়া ও ১০০ গ্রাম টিএসপি সার প্রয়োগ করতে হবে। পুকুরে প্রতি শতাংশ ৪-৬ সেমি.? দৈর্ঘ্যের সুস্থ-সবল ২০০ থেকে ২৫০টিপোনা মজুদ করা যেতে পারে।</p>
                <p className="card-text"><b>খাদ্য প্রয়োগের মাত্রা:</b><br />মজুদকৃত মাছের মোট ওজনের ৪-৫% হারে?দৈনিক দুইবার খাদ্য প্রদান করতে হয়। যথাযথ পদ্ধতিতে পরিচর্যা করা সম্ভব হলে ৬-৮ মাসে শিং মাছ বাজারজাত করার উপযোগী সাইজে উন্নীত হয়ে থাকে।</p>
                <p className="card-text"><b>সম্ভাব্যআয়: </b>এক চাষ মৌসুমে ব্যবস্থাপনা খরচ বাদে প্রতি শতাংশে ৮০০ থেকে ১০০০ টাকা আয় করা সম্ভব।</p>
                <p className="card-text"><b>মাগুর মাছ <br />আবাসস্থল :</b><br />খালবিল, হাওর-বাঁওড়, ডোবানালা, পুকুর, প্লাবনভূমি ইত্যাদি। এ মাছ এঁদো, কর্দমাক্ত মাটি, গাছের গুঁড়ির তলা, গর্ত ইত্যাদি জায়গায় বসবাস করতে পছন্দ করে। স্রোতহীন আবদ্ধ পানিতে এদের সচরাচর দেখা যায়। কচুরিপানা, পচাপাতা আগাছ বেষ্টিত জায়গায় এদের স্বচ্ছন্দে বসবাস লক্ষ্য করা যায়।</p>
                <p className="card-text"><b>খাদ্যগ্রহণপ্রবণতা: </b> এদের খাদ্য গ্রহণ প্রবণতা শিং মাছের মতোই।</p>
                <p className="card-text"><b>পরিপক্বতা: </b>এ মাছ বছরে একবার প্রজনন করে থাকে। প্রজননকালে মে থেকে আগস্ট মাস।</p>

                <p className="card-text"><b>চাষ ব্যবস্থাপনা:</b><br />১.০ থেকে ১.৫ মিটার গভীরতা বিশিষ্ট পুকুর এ মাছ চাষের জন্য উপযোগী, পুকুরের পানি শুকিয়ে পাড় মেরামত করে নিতে হবে। প্রতি শতাংশে ১ কেজি চুন, ১০ কেজি গোবর, ১০০ গ্রাম ইউরিয়া, ১০০ গ্রাম টিএসপি সার প্রয়োগ করে পুকুর প্রস্তুতিপর্ব সম্পন্ন করতে হয়। ৪-৬ সেমি.?দৈর্ঘ্যের সুস্থ-সবল পোনা পুকুরে মজুদ করা উত্তম। শতাংশপ্রতি ২০০ থেকে ২৫০টি পোনা মজুদ করা যেতে পারে। শিং মাছের মতো মাগুর মাছকেও মাছের মোট ওজনের ৪-৫% হারে?দৈনিক দুইবার খাবার সরবরাহ করতে হবে।</p>
                <p className="card-text"><b>মাগুর</b><br />মাছের খাবার হিসেবে শিং মাছের অনুরূপ উপকরণাদিসহ?তৈরি সম্পূরক খাদ্য?দৈনিক  দু’বার যথারীতি প্রদান করতে হবে। যথা নিয়মে মাছের পরিচর্যা করা সম্ভব হলে  ৮-১০ মাসেই মাগুর মাছ বাজারজাত করার উপযোগী সাইজে উন্নীত হয়ে থাকে।</p>
                <p className="card-text"><b>সম্ভাব্য আয় : </b><br />এক চাষ মৌসুমে মাগুর মাছ চাষ করে ব্যবস্থাপনা খরচাদি বাদে শতাংশ প্রতি ১০০ থেকে ১,৫০০ টাকা আয় করা সম্ভব।</p>

            </div>
        </div >


    );
};

export default ShingMagurKoiInfo;